<!-- 代码表管理 从表 -->
<template>
<div>
  <Table
    ref="table"
    :loadObj='{
      extendTreeType:$route.query.IS_TREE,
    }'
    :option="{
      extendTreeType:$route.query.IS_TREE,
    }"
    :colObj='{
      opId:"127",
      name:"代码管理",
      parentId:"TABLE_NAME",
      parentName:"代码表管理",
      parentPath:"/system/codeTable",
      dataClass:2,
      isTree:isTree,
      col:[],
    }'
  >
  </Table>
</div>
</template>

<script>
import Table from '@/components/table/treeOrTableSon';
export default {
  components: {
    Table
  },
  data() {
    return {
      firstEnter:true,
      isTree:null,
    };
  },
  computed: {
  },
  methods: {
  },
  created(){
  },
  activated(){
    this.isTree=this.$route.query.IS_TREE==1;
    if(this.firstEnter){
      this.firstEnter=false;
    }else{
      this.$refs.table.$refs.child.onLoad();
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
